<div>
    <div class="row d-flex align-items-center justify-content-between mb-5" *ngIf="!showResultsDashboard">
        <h1 class="montserrat-light text-gray-500 text-capitalize">Campaign Analytics</h1>
        <button class="btn btn-lg btn-gray-500"
                (click)="exportToPdf()" 
                [disabled]="!form.get('campaignWithLiveHistory')?.value || 
                            loading || 
                            loadingDetails || 
                            campaignNumericalMetrics.length === 0">{{ loading ? 'Exporting...' : 'Export Data' }}</button>
    </div>
    <form [formGroup]="form">
        <div>
            <div class="column">
                <div style="width: 30%" class="mb-5">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>Select a Campaign</mat-label>
                        <input type="text" matInput formControlName="campaignWithLiveHistory"
                            [matAutocomplete]="auto" 
                            #trigger="matAutocompleteTrigger"
                            (click)="trigger.openPanel()" /> 
                        <mat-icon matSuffix 
                                (click)="trigger.openPanel()" 
                                class="autocomplete-arrow">
                            expand_more
                        </mat-icon>
                        <mat-autocomplete #auto="matAutocomplete" panelClass="select-panel-down"
                            [displayWith]="displayFn" (optionSelected)="onCampaignTitleSelection($event.option.value)">
                            <mat-option *ngFor="let campaignWithLiveHistory of campaignsWithLiveHistory"
                                [value]="campaignWithLiveHistory" class="text-capitalize">
                                {{ campaignWithLiveHistory.title }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div style="display: flex; flex-direction: row; gap: 2%" *ngIf="!showResultsDashboard">
                    <div style="width: 30%">
                        <app-channel-selection-field [disabled]="allAvailableChannels.length == 0"
                            (selectionChange)="onChannelSelectionChange()" [control]="this.form.get('channels')"
                            [channels]="allAvailableChannels" [scheduleChannels]="this.form.get('channels').value"
                            (toggleAll)="toggleAllSelection()"
                            (remove)="removeScheduleChannel($event)"></app-channel-selection-field>
                    </div>
                    <div style="width: 20%">
                        <mat-form-field class="form-group dark-input">
                            <span *ngIf="liveDateRange == null || liveDateRange.length == 0">Campaign Dates</span>
                            <mat-date-range-input [disabled]="this.form.get('channels').value == null"
                                [rangePicker]="picker" [dateFilter]="dateFilter" [min]="minLiveDate"
                                [max]="maxLiveDate">
                                <input matStartDate formControlName="selectedStartDate" readonly />
                                <input matEndDate formControlName="selectedEndDate" readonly />
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker (closed)="onDatePickerClosed()"></mat-date-range-picker>
                        </mat-form-field>
                    </div>
                </div>

                <div class="column d-flex justify-content-center align-items-center"
                    *ngIf="this.form.get('campaignWithLiveHistory').value == ''">
                    <img src="./assets/images/illustrations/no-campaign-selected.svg" alt="" />
                    <div style="padding: 60px 0">
                        <h3 class="montserrat-medium text-gray-500 mb-3">No Campaign Selected</h3>
                        <p class="text-gray" style="font-size: 14px">
                            Please select a campaign from the dropdown above to view analytics
                        </p>
                    </div>
                </div>

                <div class="row mb-4 mt-3 px-3"
                    *ngIf="this.form.get('campaignWithLiveHistory').value != '' && !showResultsDashboard">
                    <div class="btn-group shadow-sm" style="border-radius: 8px; overflow: hidden; width: fit-content; border: 1px solid #e0e0e0;">
                        <button mat-button 
                            type="button"
                            [color]="viewMode === 'Estimated' ? 'primary' : ''"
                            [class.active-mode]="viewMode === 'Estimated'"
                            (click)="onViewModeChange('Estimated')"
                            style="padding: 10px 25px; border-radius: 0;">
                            Estimated
                        </button>
                        <button mat-button 
                            type="button"
                            [color]="viewMode === 'Actual' ? 'primary' : ''"
                            [class.active-mode]="viewMode === 'Actual'"
                            (click)="onViewModeChange('Actual')"
                            style="padding: 10px 25px; border-radius: 0; border-left: 1px solid #e0e0e0;">
                            Actual
                        </button>
                    </div>
                </div>

                <div class="mt-4 px-3" *ngIf="showNoActualDataDisclaimer && !showResultsDashboard">
                    <div class="alert alert-warning d-flex align-items-center" role="alert" 
                        style="background-color: #fff4e5; border: 1px solid #ffe2b3; color: #901c1c; border-radius: 8px; padding: 15px;">
                        <mat-icon class="mr-2">info</mat-icon>
                        <div>
                            <strong class="montserrat-medium">Note:</strong> 
                            This campaign has ended, but actual performance data is not yet available. 
                            All metrics shown are based on initial estimates.
                        </div>
                    </div>
                </div>

                <!--
                    The provider's own dashboard, in place of the legacy view. Gated on the
                    campaign's metrics source, not on whether figures arrived: the legacy page must
                    stay exactly as it is for every campaign that is not on the provider.
                -->
                <app-campaign-results-dashboard *ngIf="showResultsDashboard"
                    [campaignId]="selectedCampaignId" [campaignDetails]="campaignDetails"
                    [liveDateRange]="liveDateRange"></app-campaign-results-dashboard>

                <div id="pdf-export-content" *ngIf="!showResultsDashboard">
                    <div
                        *ngIf="this.form.get('campaignWithLiveHistory').value != '' && this.form.get('channels').value != null && (viewMode === 'Estimated' || hasActualData)">
                        <app-campaign-numerical-analytics [campaignDetailsInfo]="campaignDetailsInfo"
                            [campaignNumericalMetrics]="campaignNumericalMetrics"
                            [loading]="loadingDetails"></app-campaign-numerical-analytics>
                    </div>

                    <div
                        *ngIf="this.form.get('campaignWithLiveHistory').value != '' && this.form.get('channels').value != null && (viewMode === 'Estimated' || hasActualData)">
                        <div *ngFor="let campaignGraphicalMetric of campaignGraphicalMetrics">
                            <app-campaign-graphical-analytics
                                *ngIf="campaignGraphicalMetric.isAvailable"
                                [isActualMode]="viewMode === 'Actual'"
                                [allChannelsSelected]="areAllChannelsSelected()"
                                [estimatedFactorAndSpentOverTime]="campaignGraphicalMetric.estimated"
                                [factorDistributionAcrossChannel]="campaignGraphicalMetric.distribution"
                                [loading]="loadingGraphs"></app-campaign-graphical-analytics>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>